module.exports = __webpack_public_path__ + "img/detalhes_operacao_img.93e5168c.svg";